// src/pages/Services.jsx
import React from "react";
import { CodeBracketIcon, DevicePhoneMobileIcon, PencilSquareIcon, CloudIcon, ShieldCheckIcon } from "@heroicons/react/24/outline";

const services = [
  {
    title: "Custom Software Development",
    icon: CodeBracketIcon,
    image: "/software-dev.jpg",
    description: "We build scalable web and desktop applications using the latest frameworks and best practices."
  },
  {
    title: "Mobile App Development",
    icon: DevicePhoneMobileIcon,
    image: "/mobile-app.jpg",
    description: "Native and cross-platform apps that deliver smooth performance on iOS and Android devices."
  },
  {
    title: "UI/UX Design",
    icon: PencilSquareIcon,
    image: "/ui-ux.jpg",
    description: "User-centred designs that look great and feel intuitive, backed by research and prototyping."
  },
  {
    title: "Cloud & DevOps Solutions",
    icon: CloudIcon,
    image: "/cloud-devops.jpg",
    description: "End-to-end cloud architecture, CI/CD pipelines, and infrastructure automation for maximum uptime."
  },
  {
    title: "Security & Compliance",
    icon: ShieldCheckIcon,
    image: "/security.jpg",
    description: "Comprehensive security audits, encryption, and compliance readiness to keep your data safe."
  }
];

export default function Services() {
  return (
    <section className="bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-[#D7631F]">
          Our Services
        </h2>
        <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
          {services.map(({ title, icon: Icon, image, description }, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg shadow-lg overflow-hidden flex flex-col"
            >
              <div className="relative h-70 sm:h-60 md:h-74">
                <img
                  src={image}
                  alt={title}
                  className="object-cover w-full h-full"
                />
                <div className="absolute top-4 left-4 bg-white rounded-full p-2 shadow">
                  <Icon className="w-6 h-6 text-[#D7631F]" />
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-2xl font-semibold mb-2">{title}</h3>
                <p className="text-gray-600 flex-1">{description}</p>
                <a
                  href="/contact"
                  className="mt-4 inline-block text-[#D7631F] font-semibold hover:underline"
                >
                  Get a Quote →
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
